import React, { useState, useEffect, useRef } from "react";
import InputField from "../../components/Form/InputField";
import api from "../../api";
import { toEnglishNumbers } from "../../utils/toEnglishNumber";
import Button from "../../components/Button";
import {FiUpload, FiDownload} from "react-icons/fi";
import * as XLSX from "xlsx";
import {exportToExcel} from "../../utils/exportToExcel";

export default function BusinessCalendar() {
  const [selectedDate, setSelectedDate] = useState("");
  const [dayData, setDayData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    description: "",
    is_holiday: false,
    is_weekend: false,
    is_business_day: true,
    start_time: "",
    finish_time: "",
  });
  const [file, setFile] = useState(null);
  const fileInputRef = useRef();

  const handleChange = (e) => {
    setSelectedDate(toEnglishNumbers(e.target.value));
  };

  // وقتی یک فیلد فرم تغییر کند
  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // تابع برای باز کردن پنجره انتخاب فایل
  const handleOpenFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  // پس از انتخاب فایل، فایل را ثبت و به API می‌فرستیم
  const handleFileSelected = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile); // در صورت نیاز می‌توانید این را برای نمایش استفاده کنید

    // ارسال فایل به API
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      setLoading(true);
      const res = await api.post(
        "/operation/calendar/bulk_upload/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert("اطلاعات با موفقیت بارگذاری شد.");
    } catch (err) {
      console.error("Upload error:", err);
      alert("خطا در بارگذاری فایل. لطفا مجدد تلاش کنید.");
    } finally {
      setLoading(false);
      // صفر کردن فایل در صورت نیاز
      setFile(null);
    }
  };

  const handleExportExcel = async () => {

    try {
      const { data } = await api.get(
        "/operation/calendar/",
      );

      if (!data.length) {
        alert("داده‌ای برای خروجی وجود ندارد");
        return;
      }

      const ExcelData = data.map(day => ({
        gregorian_date: day.gregorian_date ?? "",
        jalali_year: day.jalali_year ?? "",
        jalali_month: day.jalali_month ?? "",
        jalali_day: day.jalali_day ?? "",
        weekday: day.weekday ?? "",
        description: day.description ?? "",
        is_holiday: day.is_holiday ?? "",
        is_weekend: day.is_weekend ?? "",
        is_business_day: day.is_business_day ?? "",
        start_time: day.start_time ?? "",
        finish_time: day.finish_time ?? "",
      }));

        exportToExcel(ExcelData, `تقویم اختصاصی`, {
          headers: {
            gregorian_date: "تاریخ میلادی",
            jalali_year: "سال",
            jalali_month:"ماه",
            jalali_day: "روز",
            weekday:"روز هفته",
            description:"مناسبت",
            is_holiday:"تعطیلات رسمی",
            is_weekend:"تعطیلات آخر هفته",
            is_business_day:"روز کاری",
            start_time:"ساعت شروع",
            finish_time:"ساعت پایان",
          },
        });

    } catch (err) {
      console.error(err);
      alert("خطا در دریافت اطلاعات روزها");
    }
  };


  // دریافت اطلاعات روز
  useEffect(() => {
    if (!selectedDate) {
      setDayData(null);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await api.get(
          `/operation/calendar/by-date/${selectedDate}/`
        );

        setDayData(res.data);

        // پر کردن فرم با داده‌های دریافت‌شده
        setForm({
          description: res.data.description || "",
          is_holiday: res.data.is_holiday,
          is_weekend: res.data.is_weekend,
          is_business_day: res.data.is_business_day,
          start_time: res.data.start_time || "",
          finish_time: res.data.finish_time || "",
        });

      } catch (err) {
        console.error("Error loading date data:", err);
        setDayData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);



  // ارسال ویرایش
  const handleSubmit = async () => {
    if (!dayData?.gregorian_date) return;

    try {
      const payload = {
        ...form,
        gregorian_date: dayData.gregorian_date,
        jalali_year: dayData.jalali_year,
        jalali_month: dayData.jalali_month,
        jalali_day: dayData.jalali_day,
        weekday: dayData.weekday,
      };

      await api.put(
        `/operation/calendar/${dayData.id}/`,
        payload
      );

      alert("ویرایش با موفقیت انجام شد!");

    } catch (error) {
      console.error("Error updating record:", error);
      alert("خطا در ویرایش اطلاعات");
    }
  };

  return (
  <div className="p-4 space-y-4 border rounded-xl bg-white shadow">
    {/* --- سطر اول: انتخاب فایل | دانلود اکسل | انتخاب تاریخ --- */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-center">

      {/* دکمه انتخاب فایل اکسل */}
      <Button
        variant={"primary"}
        onClick={handleOpenFileDialog}
        disabled={loading}
        icon={<FiUpload className="w-5 h-5 ml-2" />}
        children={loading ? "در حال بارگذاری..." : "بارگذاری فایل اکسل"}
      />

      {/* input مخفی فایل */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx, .xls"
        style={{ display: "none" }}
        onChange={handleFileSelected}
      />

      {/* دکمه دانلود اکسل */}
      <Button
        variant={"secondary"}
        children={"دریافت فایل اکسل"}
        onClick={handleExportExcel}
        icon={<FiDownload className="w-5 h-5 ml-2" />}
      />

      {/* انتخاب تاریخ — سایز کوچک طبق درخواست */}
      <div className="w-full flex justify-center md:justify-end">
        <div className="w-[200px]">
          <InputField
            label="تعیین تاریخ"
            name="gregorian_date"
            type="date"
            value={selectedDate}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>

    {file && (
      <p className="text-sm text-gray-700">فایل انتخاب شده: {file.name}</p>
    )}

    {loading && <p>در حال دریافت اطلاعات...</p>}

    {/* --- جزئیات روز --- */}
    {dayData && (
      <div className="mt-4 p-4 rounded border bg-gray-50 space-y-4">

        {/* سطر: تاریخ شمسی و روز هفته */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <p className=" text-sm">
            تاریخ میلادی: {`${dayData.gregorian_date}`}
          </p>

          <p className="text-sm">
            روز هفته: {dayData.weekday}
          </p>
        </div>

        {/* --- سطر: ساعت شروع / پایان / (همراه با تارخ و روز هفته در یک ردیف) --- */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">



          <InputField
            label="ساعت شروع"
            name="start_time"
            type="time"
            value={form.start_time}
            onChange={handleFormChange}
          />

          <InputField
            label="ساعت پایان"
            name="finish_time"
            type="time"
            value={form.finish_time}
            onChange={handleFormChange}
          />
        </div>

        {/* --- سطر: چک‌باکس‌ها --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

          <div className="flex items-center gap-2 bg-white border rounded p-2">
            <input
              type="checkbox"
              name="is_holiday"
              checked={form.is_holiday}
              onChange={handleFormChange}
            />
            <label>تعطیل رسمی</label>
          </div>

          <div className="flex items-center gap-2 bg-white border rounded p-2">
            <input
              type="checkbox"
              name="is_weekend"
              checked={form.is_weekend}
              onChange={handleFormChange}
            />
            <label>آخر هفته</label>
          </div>

          <div className="flex items-center gap-2 bg-white border rounded p-2">
            <input
              type="checkbox"
              name="is_business_day"
              checked={form.is_business_day}
              onChange={handleFormChange}
            />
            <label>روز کاری</label>
          </div>

        </div>

        {/* --- سطر آخر: مناسبت‌ها --- */}
        <div>
          <InputField
            label="توضیحات (مناسبت)"
            name="description"
            type="text"
            value={form.description}
            onChange={handleFormChange}
          />
        </div>

        {/* --- دکمه ثبت --- */}
        <Button
          variant={"primary"}
          onClick={handleSubmit}
          children={'ثبت تغییرات'}
        />
      </div>
    )}
  </div>
);

}
